<mat-card *ngIf="!updateMode">{{'addSubCategory' | translate}}</mat-card>
<mat-card *ngIf="updateMode">{{'updateSubCategory' | translate}}</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">
  <span class="spacer"></span>

  <button mat-raised-button color="primary" (click)="submit()" *ngIf="!_submit"
    [disabled]="arabName.invalid || engName.invalid || searchCategory.invalid">
    <mat-icon>done</mat-icon>
    {{'submit' | translate}}
  </button>
  &nbsp;
  <button mat-raised-button color="primary" (click)="addNew()" *ngIf="_submit">
    <mat-icon>add</mat-icon>
    {{'addNew' | translate}}
  </button>
  &nbsp;
  <button mat-raised-button (click)="back()">
    <mat-icon>keyboard_backspace</mat-icon>
    {{'back' | translate}}
  </button>
  &nbsp;
</div>

<mat-grid-list cols="8" rowHeight="100px">


  <mat-grid-tile colspan="2">
    &nbsp;
    <mat-form-field appearance="standard" class="example-full-width" style="margin-left: 3px;">
      <mat-label>{{'selectCategory' | translate}}</mat-label>
      <input type="text" matInput [formControl]="searchCategory" required [matAutocomplete]="auto">
      <button mat-button matSuffix mat-icon-button>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCatChange($event.option.value)"
        [displayWith]="displayFn">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
          <img class="example-option-img" aria-hidden [src]="imagPath + option.imageUrl" height="25" width="25"
            style="object-fit: fill;">
          <span>&nbsp;</span>
          <span>{{language == 1 ? option.arabicName : option.englishName}}</span>
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="searchCategory.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>
    <span>&nbsp;</span>

  </mat-grid-tile>

  <mat-grid-tile colspan="1">
    <mat-form-field appearance="standard" style="margin-right: 5px;">
      <mat-label>{{'directCharged' | translate}}</mat-label>
      <mat-select [(value)]="subCategory.directCharge">
        <mat-option [value]="true"> {{'yes' | translate}} </mat-option>
        <mat-option [value]="false"> {{'no' | translate}} </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>

  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'arabicName' | translate}}</mat-label>
      <input matInput [(ngModel)]="subCategory.arabicName" required #arabName="ngModel" name="arabicName">
      <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>

  </mat-grid-tile>

  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'englishName' | translate}}</mat-label>
      <input matInput [(ngModel)]="subCategory.englishName" required #engName="ngModel" name="englishName">
      <mat-error *ngIf="engName.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile colspan="1">
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="active" name="active">{{'active' | translate}}
    </mat-checkbox>
  </mat-grid-tile>

</mat-grid-list>

<mat-grid-list cols="6" rowHeight="100px" *ngIf="subCategory.directCharge">

  <mat-grid-tile colspan="1">
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="subCategory.view_userName">
      اسم المستخدم
    </mat-checkbox>
  </mat-grid-tile>

  <mat-grid-tile colspan="1">
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="subCategory.view_password">
      كلمة السر
    </mat-checkbox>
  </mat-grid-tile>

  <mat-grid-tile colspan="1">
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="subCategory.view_email">
      الايميل
    </mat-checkbox>
  </mat-grid-tile>

  <mat-grid-tile colspan="1">
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="subCategory.view_playerId">
      معرف اللاعب
    </mat-checkbox>
  </mat-grid-tile>


</mat-grid-list>

<mat-grid-list cols="6" rowHeight="100px" *ngIf="subCategory.directCharge">

  <mat-grid-tile colspan="1">
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="subCategory.view_phoneNumber">
      رقم الهاتف
    </mat-checkbox>
  </mat-grid-tile>

  <mat-grid-tile colspan="1">
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="subCategory.view_busCardNumber">
      بطاقة الباص السريع
    </mat-checkbox>
  </mat-grid-tile>

  <mat-grid-tile colspan="1">
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="subCategory.view_CardNumber">
      رقم البطاقة
    </mat-checkbox>
  </mat-grid-tile>

  <mat-grid-tile colspan="1">
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="subCategory.view_playerName">
      اسم اللاعب
    </mat-checkbox>
  </mat-grid-tile>


</mat-grid-list>


<mat-grid-list cols="3" rowHeight="200px">
  <mat-grid-tile></mat-grid-tile>
  <mat-grid-tile>
    <!-- <mat-label>Image</mat-label> -->
    <input type="file" class="dropify" (change)="onSelectImage($event)" />
  </mat-grid-tile>
</mat-grid-list>

<!-- <br />

<mat-accordion class="example-headers-align" multi>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        طريقة استخدام البطاقة
      </mat-panel-title>

    </mat-expansion-panel-header>
    <div [ngxSummernote]="config" [(summernoteModel)]="subCategory.cardsHowToUse"></div>

  </mat-expansion-panel>
</mat-accordion> -->


<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>